import { render, staticRenderFns } from "./WidgetsDashboardQuickMenu.vue?vue&type=template&id=d15596a4"
import script from "./WidgetsDashboardQuickMenu.vue?vue&type=script&lang=js"
export * from "./WidgetsDashboardQuickMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports